<form [formGroup]="form()">
  <div class="row">
    @if (isSelfRegistration()) {
      <app-info-box class="col-12 mb20">
        <span>{{ 'contact.selfRegistration_timer_text_l' | translate }}</span>
      </app-info-box>
    }
  </div>
  <div class="row">
    @if (!isSelfRegistration()) {
      <div class="col-12 mb20" [class.col-md-6]="hasOfflineUserAccess()">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.membership_number_l' | translate }}
          </app-form-field-label>
          <input
            appInput
            type="text"
            [placeholder]="'forms.type_membership_number' | translate"
            formControlName="membershipNumber"
            class="form-control"
          />
        </app-form-field>
      </div>
    }
    @if (hasOfflineUserAccess() && !isSelfRegistration()) {
      <div class="col-12 col-md-6 mb20">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.member_status_l' | translate }}
            <app-hint class="ps-1"
              >{{ 'contact.member_status_hint_l' | translate }}
            </app-hint>
          </app-form-field-label>
          <app-select
            [items]="memberTypes"
            formControlName="propertySearcherType"
            [readonly]="isExistingOnlineContact()"
          >
          </app-select>
        </app-form-field>
      </div>
    }

    <div class="col-12 col-md-6 mb20" formGroupName="data">
      <app-form-field>
        <app-form-field-label
          >{{ 'general.first_name_l' | translate }}
        </app-form-field-label>
        <input
          appInput
          [placeholder]="'forms.type_name' | translate"
          required
          formControlName="firstname"
          class="form-control"
        />
      </app-form-field>
    </div>

    <div class="col-12 col-md-6 mb20" formGroupName="data">
      <app-form-field>
        <app-form-field-label
          >{{ 'general.last_name_l' | translate }}
        </app-form-field-label>
        <input
          appInput
          [placeholder]="'forms.type_name' | translate"
          required
          formControlName="name"
          class="form-control"
        />
      </app-form-field>
    </div>

    @if (offlineContactExists() && isOfflineUser) {
      <span class="col-12 mb20 combination-exists">
        {{ 'contact.offline_name_combination_exists_l' | translate }}
      </span>
    }
    @if (!isOfflineUser) {
      <div class="col-12 col-md-6 mb20">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.email_address_l' | translate }}
          </app-form-field-label>
          <input
            appInput
            [placeholder]="'forms.type_email' | translate"
            formControlName="email"
            class="form-control"
          />
        </app-form-field>
      </div>
    }
    @if (!isOfflineUser) {
      <div formGroupName="data" class="col-12 col-md-6 mb20">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.birthdate_l' | translate }}
          </app-form-field-label>
          <app-date
            [required]="false"
            formControlName="birthday"
            [startDate]="startDateStruct"
            [maxDate]="maxDateStruct"
            [minDate]="minDateStruct"
          ></app-date>
        </app-form-field>
      </div>
    }
    @if (emailContactExists() && !isOfflineUser) {
      <span class="col-12 mb20 combination-exists">
        {{ 'contact.online_email_combination_exists_l' | translate }}
      </span>
    }
    <app-address-form
      class="col-12 mb20"
      [formGroup]="addressGroup"
      [showDistricts]="false"
      [config]="addressConfig"
    ></app-address-form>

    @if (availableLanguages()) {
      <div class="col-6 mb20">
        <app-form-field>
          <app-form-field-label [showRequiredMarker]="true"
            >{{ 'general.preferred_language_l' | translate }}
            <app-hint class="ps-1"
              >{{ 'internal_list.preferred_language_hint_m' | translate }}
            </app-hint>
          </app-form-field-label>
          <app-dropdown-select
            [items]="availableLanguages()"
            formControlName="preferredLanguage"
            itemValueKey="code"
          >
            <div dropdown-button>
              {{
                'internal_list.preferred_language_select.language' | translate
              }}
            </div>
            <ng-template let-item>{{ item.label | translate }}</ng-template>
          </app-dropdown-select>
        </app-form-field>
      </div>
    }

    <ng-container formGroupName="data">
      <div class="col mb20">
        <app-form-field>
          <app-form-field-label [showRequiredMarker]="isOfflineUser"
            >{{ 'general.telephone_l' | translate }}
          </app-form-field-label>

          <input
            appInput
            type="text"
            [placeholder]="'forms.type_phone' | translate"
            [required]="isOfflineUser"
            formControlName="phone"
            class="form-control"
          />
        </app-form-field>
      </div>

      @if (!isSelfRegistration()) {
        <div class="col-12 col-md-6 mb20">
          <app-form-field>
            <app-form-field-label
              >{{ 'general.member_entry_date_l' | translate }}
            </app-form-field-label>
            <app-date formControlName="entryDate" [required]="false"></app-date>
          </app-form-field>
        </div>
        <div class="col-12 col-md-6 mb20">
          <app-form-field>
            <app-form-field-label
              >{{ 'general.member_leaving_date_l' | translate }}
            </app-form-field-label>
            <app-date formControlName="leavingDate"></app-date>
          </app-form-field>
        </div>
      }
    </ng-container>

    @if (isOfflineUser) {
      <div class="col-12 col-md-6 mb20">
        <app-form-field>
          <app-form-field-label
            >{{ 'general.move_in_date_l' | translate }}
          </app-form-field-label>
          <app-date formControlName="moveInDate" [minDate]="minDate"></app-date>
        </app-form-field>
      </div>
    }
    @if (hasCooperativeModule()) {
      <div class="col-12 col-md-6 mb20">
        <ng-container formGroupName="data">
          <app-form-field>
            <app-form-field-label
              >{{ 'general.member_wating_since_l' | translate }}
            </app-form-field-label>
            <app-date
              formControlName="waitingSince"
              [maxDate]="maxDateStruct"
            ></app-date>
          </app-form-field>
        </ng-container>
      </div>
    }
    @if (isOfflineUser) {
      <div class="col-12" formGroupName="housingPermission">
        <app-form-field class="d-block mb20">
          <app-form-field-label
            >{{ 'general.housing_permission_type_l' | translate }}
          </app-form-field-label>
          <app-select
            [items]="housingPermissionTypes"
            formControlName="type"
          ></app-select>
        </app-form-field>
        @if (housingPermissionTypeControl.value) {
          <app-form-field>
            <app-form-field-label
              >{{ 'general.housing_permission_amount_people_l' | translate }}
            </app-form-field-label>
            <input
              appInput
              [placeholder]="
                'forms.type_housing_permission_amount_people' | translate
              "
              [required]="false"
              formControlName="amountPeople"
              class="form-control"
              type="number"
              min="0"
            />
          </app-form-field>
        }
      </div>
    }
  </div>
</form>
